<div class="repasse-list ui-page-skeleton-modern">
  <div class="container">
    <div class="container-conteudo conteudo d-flex direction-column">
      <!-- <div class="conteudo-page-header repasse-list__page-header page-header d-flex align-center">
        <span class="page-header-separator" aria-hidden="true"></span>
        <h1 class="page-header-title">Repasse de Comissão</h1>
      </div> -->

      <div class="conteudo-filters">
        <section class="filter-accordion">
          <button type="button" class="filter-accordion-header" (click)="toggleFiltersVisibility()"
            [attr.aria-expanded]="isFiltersExpanded" aria-controls="repasse-filter-body">
            <span class="filter-accordion-title">Filtros</span>
            <span class="filter-accordion-toggle-label">{{ isFiltersExpanded ? 'ocultar' : 'mostrar' }}</span>
          </button>

          <div class="filter-accordion-body" id="repasse-filter-body" *ngIf="isFiltersExpanded">
            <section class="filter-panel">

              <div class="repasse-search">
                <label class="ui-field-label" for="repasse-search-input">Buscar</label>
                <div class="repasse-search__box">
                  <input id="repasse-search-input" class="ui-search-input" type="text"
                    placeholder="Buscar por lote, parceiro, NF, contrato ou proposta" [formControl]="queryField"
                    (keyup.enter)="applyRepasseFilters()" />
                  <app-svg-icon class="repasse-search__icon" width="15px" height="17px" color="arrowGray"
                    src="assets/icons/search-icon.svg" alt="search">
                  </app-svg-icon>
                </div>
              </div>

              <div class="contexts-grid">
                <div class="repasse-filter-field">
                  <label class="ui-field-label" for="repasse-filter-status-lote-trigger">Status do Lote</label>
                  <div class="commission-combo-wrap">
                    <button id="repasse-filter-status-lote-trigger" class="commission-combo-trigger" type="button"
                      (click)="toggleDropdown($event, 'transferStatuses')">
                      <span>{{ getTransferStatusTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>
                    <div class="commission-combo-dropdown" role="presentation" *ngIf="openDropdown === 'transferStatuses'"
                      (click)="$event.stopPropagation()">
                      <label class="commission-combo-option" *ngFor="let status of transferStatusOptions">
                        <input class="commission-combo-checkbox" type="checkbox"
                          [checked]="isTransferStatusSelected(status)"
                          (change)="toggleTransferStatus(status, $any($event.target).checked)" />
                        <span class="commission-combo-checkmark" aria-hidden="true"></span>
                        <span class="commission-combo-option-text">{{ status }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="repasse-filter-field">
                  <label class="ui-field-label" for="repasse-filter-status-omie-trigger">Status do OMIE</label>
                  <div class="commission-combo-wrap">
                    <button id="repasse-filter-status-omie-trigger" class="commission-combo-trigger" type="button"
                      (click)="toggleDropdown($event, 'orderStatuses')">
                      <span>{{ getOrderStatusTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>
                    <div class="commission-combo-dropdown" role="presentation" *ngIf="openDropdown === 'orderStatuses'"
                      (click)="$event.stopPropagation()">
                      <label class="commission-combo-option" *ngFor="let status of orderStatusOptions">
                        <input class="commission-combo-checkbox" type="checkbox"
                          [checked]="isOrderStatusSelected(status)"
                          (change)="toggleOrderStatus(status, $any($event.target).checked)" />
                        <span class="commission-combo-checkmark" aria-hidden="true"></span>
                        <span class="commission-combo-option-text">{{ status }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="repasse-filter-field">
                  <label class="ui-field-label" for="repasse-filter-status-pagamento-trigger">Status Pagamento</label>
                  <div class="commission-combo-wrap">
                    <button id="repasse-filter-status-pagamento-trigger" class="commission-combo-trigger" type="button"
                      (click)="toggleDropdown($event, 'paymentStatuses')">
                      <span>{{ getPaymentStatusTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>
                    <div class="commission-combo-dropdown" role="presentation" *ngIf="openDropdown === 'paymentStatuses'"
                      (click)="$event.stopPropagation()">
                      <label class="commission-combo-option" *ngFor="let status of paymentStatusOptions">
                        <input class="commission-combo-checkbox" type="checkbox"
                          [checked]="isPaymentStatusSelected(status)"
                          (change)="togglePaymentStatus(status, $any($event.target).checked)" />
                        <span class="commission-combo-checkmark" aria-hidden="true"></span>
                        <span class="commission-combo-option-text">{{ status }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="repasse-filter-field repasse-filter-field--range">
                  <span class="ui-field-label">Período do Lote</span>
                  <div class="repasse-date-range">
                    <app-c-input [formControl]="batchDateFrom" inputType="date" class="form-input" label="Início">
                    </app-c-input>
                    <span class="repasse-date-range__sep" aria-hidden="true">→</span>
                    <app-c-input [formControl]="batchDateTo" inputType="date" class="form-input" label="Fim">
                    </app-c-input>
                  </div>
                </div>

                <div class="repasse-filter-field repasse-filter-field--range">
                  <span class="ui-field-label">Alteração de Contratos</span>
                  <div class="repasse-date-range">
                    <app-c-input [formControl]="contractInclusionDateFrom" inputType="date" class="form-input"
                      label="Início">
                    </app-c-input>
                    <span class="repasse-date-range__sep" aria-hidden="true">→</span>
                    <app-c-input [formControl]="contractInclusionDateTo" inputType="date" class="form-input"
                      label="Fim">
                    </app-c-input>
                  </div>
                </div>

                <div class="repasse-list__summary-row">
                  <div class="repasse-list__filter-actions">
                    <button type="button" class="ui-btn ui-btn--secondary" (click)="clearRepasseFilters()">
                      Limpar filtros
                    </button>
                    <button type="button" class="ui-btn ui-btn--primary" (click)="applyRepasseFilters()">
                      Buscar
                    </button>
                  </div>
                </div>

              </div>
            </section>
          </div>
        </section>
      </div>

      <div class="conteudo-list" #repasseHeaderRegion>
        <div class="conteudo-list-placeholder" *ngIf="isHeaderPinned"
          [style.height.px]="headerHeight">
        </div>

        <div #headerFix class="conteudo-list-fix" [class.conteudo-list-fix-pinned]="isHeaderPinned"
        [style.left.px]="isHeaderPinned ? headerLeft : null"
          [style.width.px]="isHeaderPinned ? headerWidth : null">
          <div class="conteudo-list-toolbar toolbar d-flex align-center">
            <div class="repasse-list__summary">
              <span class="ui-summary-pill">
                <small>Selecionados</small>
                <strong>{{ checkAll ? (lotsList.length - exceptionsBatches.length) : checkedBatches.length }}</strong>
              </span>
            </div>

            <div class="repasse-top-actions d-flex align-center">
              <div class="repasse-email-container">
                <div class="d-flex align-center repasse-email-actions">
                  <button type="button"
                    class="ui-btn repasse-action-btn repasse-top-action-btn d-flex justify-center align-center"
                    [disabled]="!canSendTransferEmail" (click)="handleSendInvoiceEmail(false)">
                    <app-svg-icon src="../../../../assets/icons/email-icon.svg" color="white" width="15px"
                      height="15px">
                    </app-svg-icon>
                    <span class="repasse-action-btn__label">Enviar e-mail NF</span>
                  </button>
                  <button type="button"
                    class="ui-btn repasse-action-btn repasse-top-action-btn d-flex justify-center align-center"
                    [disabled]="!canSendTransferPaymentEmail" (click)="handleSendInvoiceEmail(true)">
                    <app-svg-icon src="../../../../assets/icons/email-icon.svg" color="white" width="15px"
                      height="15px">
                    </app-svg-icon>
                    <span class="repasse-action-btn__label">Enviar e-mail pgto</span>
                  </button>
                  <!-- <button class="ui-btn ui-btn--secondary repasse-action-btn d-flex justify-center align-center" type="button" 
                      (click)="exportToClipboardTransfer()">
                      Copiar
                    </button> -->
                </div>
              </div>

              <div class="repasse-create-actions d-flex align-center">
                <button type="button" class="ui-btn repasse-action-btn repasse-top-action-btn"
                  [disabled]="isLoadingAutomatic" (click)="handleProcessAutomaticTransferBatches()">
                  <app-svg-icon src="../../../../assets/icons/reload-icon.svg" color="white" width="15px" height="15px">
                  </app-svg-icon>
                  <span class="repasse-action-btn__label">Gerar lote automático</span>
                </button>
                <button type="button" class="ui-btn repasse-action-btn repasse-top-action-btn repasse-icon-only-btn"
                  matTooltip="Ver última execução do loteamento automático" aria-label="Ver última execução do loteamento automático"
                  (click)="viewLatestAutomaticBatchExecution()">
                  <app-svg-icon src="assets/icons/view-icon.svg" color="white" width="15px" height="15px">
                  </app-svg-icon>
                </button>
                <button type="button" class="ui-btn repasse-action-btn repasse-top-action-btn"
                  (click)="insertManualBatch()">
                  <app-svg-icon src="../../../../assets/icons/plus-solid-icon.svg" color="white" width="13px"
                    height="13px">
                  </app-svg-icon>
                  <span class="repasse-action-btn__label">Criar novo lote</span>
                </button>
              </div>
            </div>
          </div>

          <div class="conteudo-list-header header d-flex align-center">
            <app-ordered-header-list [headerItems]="headerItems" (orderChangeEvent)="orderChange($event)">

              <ng-container headerFlag>
                <div class="flex-1 content-flag repasse-index-check-cell">
                  <span class="repasse-index-check-cell__index">#</span>
                  <app-c-checkbox class="repasse-index-check-cell__checkbox" [checked]="checkAll"
                    [disabled]="lotsList.length === 0" [controlDisabled]="lotsList.length === 0" [id]="'all'"
                    (change)="changeInvoiceHeaderCheckbox()"></app-c-checkbox>
                </div>
              </ng-container>

            </app-ordered-header-list>
          </div>
        </div>

        <div #listBody class="conteudo-contracts contracts d-flex direction-column row-gap-8">
          <app-skeleton *ngIf="isLoading" variant="table-row" [rows]="8" [columns]="headerItems.length"></app-skeleton>

          <ng-container *ngIf="!isLoading">
            <ng-container *ngFor="let lote of lotsList; let i = index">
              <app-card-lotes-repasse [lote]="lote" [tabType]="'solicitado'">
                <ng-container cardFlag>
                  <div class="flex-1 content-flag repasse-index-check-cell">
                    <span class="repasse-index-check-cell__index">{{ i + 1 }}</span>
                    <app-c-checkbox class="repasse-index-check-cell__checkbox" [checked]="checkCardFlag(lote)"
                      [disabled]="disabledCardFlag(lote)" [id]="lote.BatchId"
                      [controlDisabled]="disabledCardFlag(lote)"
                      (change)="changeInvoiceCardCheckbox(lote.BatchId.toString())"></app-c-checkbox>
                  </div>
                </ng-container>
              </app-card-lotes-repasse>
            </ng-container>
            <div *ngIf="lotsList.length === 0" class="contracts-empty empty">
              <span class="empty-message"> Não há lotes disponíveis </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngIf="count > lotsList.length">
      <app-scroll-pagination [count]="count" (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
    </ng-container>
  </div>
</div>
